const tabsItem = document.querySelectorAll('.earning-summary-tabs__navigation-item'),
    tabsContent = document.querySelectorAll('.earning-summary-tabs__content-item');

function summaryTab(nav) {
    [ ...nav ].forEach(e => {
        e.addEventListener('click', function H() {
            let __this = this;
            [ ...__this.parentNode.querySelectorAll('.earning-summary-tabs__navigation-item') ].forEach(el => {
                el.classList.remove('isActive');
                __this.classList.remove('isActive');
            });
            __this.classList.add('isActive');

            let tabNameBenefit = __this.dataset.awardstab;
            [ ...__this.parentNode.parentNode.parentNode.querySelectorAll('.earning-summary-tabs__content-item') ].forEach(e => {
                if(e.classList.contains(tabNameBenefit)) {
                    e.classList.add('isActive');
                } else {
                    e.classList.remove('isActive');
                }
            });
        });
    });
}
summaryTab(tabsItem, tabsContent);
